import { Post } from '../api-middleware';
import { apiPath } from '@/constants/defaultValues';
import {GetAllDashBoardDetailsUrl,GetAllDashBoardDetailsForSpecificDayUrl,} from '../api-request/dashboard-requests';


const GetAllDashBoardDetails = async (dashBoardRequest) => {
  const response = await Post({
    url: `${apiPath}${GetAllDashBoardDetailsUrl}`,
    data: dashBoardRequest,
  });
  return response;
};

const GetAllDashBoardDetailsForSpecificDay = async (dashBoardRequest) => {
  const response = await Post({
    url: `${apiPath}${GetAllDashBoardDetailsForSpecificDayUrl}`,
    data: dashBoardRequest,
  });
  return response;
};

const DashBoard = {
  GetAllDashBoardDetails,
  GetAllDashBoardDetailsForSpecificDay,
};
export default DashBoard;
